const mockUser = {
  id: '1',
  createdAt: null,
  updatedAt: null,
  archivedAt: null,
  initials: 'TU',
  userName: 'Test User',
  firstName: 'Test',
  lastName: 'User',
  displayName: 'Test User',
  email: 'testuser@example.com',
  phoneNumber: '123-456-7890',
  role: null,
  enableDebugLogs: false,
  userDisplayName: 'Test User',
  color: '#00cc8c'
}

export default mockUser
